import ScopedStringListSchema from '../schemas/ScopedStringListSchema'

export default function ScopedStringListVo(initData = {}) {
  return ScopedStringListSchema.validateSync(initData)
}
